import { useEffect } from 'react';

import { useOneTimeMessagesDismissed } from '@trello/business-logic-react/member';
import { useGetExperimentValue } from '@trello/feature-gate-client';
import { useSplitScreenSharedState } from '@trello/split-screen';

import { useIsEligibleForQuickCaptureDiscovery } from 'app/src/components/QuickCaptureDiscovery/useIsEligibleForQuickCaptureDiscovery';

const INBOX_FORCE_OPEN_MESSAGE_ID = 'inbox-force-open-qc-discovery';

export const useForceOpenInbox = (
  splitScreenSharedStateArgs: Parameters<typeof useSplitScreenSharedState>[0],
) => {
  const { panels, toggleInbox } = useSplitScreenSharedState(
    splitScreenSharedStateArgs,
  );

  // Mechanism to enforce force-open happens at most once.
  const { dismissOneTimeMessage, isOneTimeMessageDismissed } =
    useOneTimeMessagesDismissed();

  const isEligibleForQuickCaptureDiscovery =
    useIsEligibleForQuickCaptureDiscovery();

  const { qcDiscoveryUx } = useGetExperimentValue({
    experimentName: 'ghost_qc_discovery',
    parameter: 'qcDiscoveryUx',
  });

  const doForceOpenInbox =
    isEligibleForQuickCaptureDiscovery && qcDiscoveryUx !== 'not-enrolled';

  useEffect(() => {
    if (
      doForceOpenInbox &&
      !isOneTimeMessageDismissed(INBOX_FORCE_OPEN_MESSAGE_ID)
    ) {
      if (!panels.inbox) {
        toggleInbox();
      }
      // If the inbox is already open, count this as a force-open.
      dismissOneTimeMessage(INBOX_FORCE_OPEN_MESSAGE_ID);
    }
  }, [
    doForceOpenInbox,
    toggleInbox,
    panels.inbox,
    dismissOneTimeMessage,
    isOneTimeMessageDismissed,
  ]);
};
